// extracted by mini-css-extract-plugin
export var bounce = "_lx-1";
export var generatingText = "_lx-6";
export var lightning = "_lx-4";
export var popup = "_lx-5";
export var progressBar = "_lx-7";
export var progressFill = "_lx-8";
export var progressShimmer = "_lx-9";
export var progressText = "_lx-a";
export var shimmer = "_lx-3";
export var uploadIcon = "_lx-0";
export var uploadingText = "_lx-2";